<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Delivery Instruction" active>

                                <b-row v-if="hasFailedDataDeliveryInstruction">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryInstruction.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionsFailed" :fields="fieldsDeliveryInstruction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstruction" :sort-desc.sync="sortDescDeliveryInstruction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(diDeliveryDate)="row">
													{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(diCreateDate)="row">
													{{ row.item.diCreateDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryInstruction.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructions" :fields="fieldsDeliveryInstruction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstruction" :sort-desc.sync="sortDescDeliveryInstruction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(diDeliveryDate)="row">
													{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(diCreateDate)="row">
													{{ row.item.diCreateDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Delivery Instruction Detail" active>

                                <b-row v-if="hasFailedDataDeliveryInstructionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryInstructionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionDetailsFailed" :fields="fieldsDeliveryInstructionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionDetail" :sort-desc.sync="sortDescDeliveryInstructionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDelivery)="row">
													{{ Number(row.item.qtyDelivery).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryInstructionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionDetails" :fields="fieldsDeliveryInstructionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionDetail" :sort-desc.sync="sortDescDeliveryInstructionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDelivery)="row">
													{{ Number(row.item.qtyDelivery).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionList from '@/models/DeliveryInstruction/DeliveryInstructionList';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDeliveryInstruction: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "DeliveryOrder", key: 'deliveryOrderDoNumber', sortable: false},
				{"class" : "th-status", "label" : "PO No Customer", key: 'poNoCustomer', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'diDeliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Created Date", key: 'diCreateDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Status", key: 'diStatusName', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'diCustomerCode', sortable: false},
				{"class" : "th-status", "label" : "Part Destination", key: 'partDestinationDestination', sortable: false},
				{"class" : "th-status", "label" : "Destination", key: 'destinationCode', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsDeliveryInstructionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Delivery", key: 'qtyDelivery', sortable: false},
				{"class" : "th-status", "label" : "Delivery Order Detail", key: 'deliveryOrderDetailPoNumber', sortable: false},
				{"class" : "th-status", "label" : "Is Need Regenerate DC", key: 'isNeedRegenerateDc', sortable: false},
				{"class" : "th-status", "label" : "Need Repack Qty", key: 'needRepackQty', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual Supply", key: 'qtyActualSupply', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Status", key: 'deliveryInstructionStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			deliveryInstructions : [],
			deliveryInstructionsFailed: [],
			deliveryInstructionId : '',
			sortByDeliveryInstruction: '',
			sortDescDeliveryInstruction: '',
			hasFailedDataDeliveryInstruction: false,
			totalFailedDeliveryInstruction: 0,
			totalSucceedDeliveryInstruction: 0,
			deliveryInstructionDetails : [],
			deliveryInstructionDetailsFailed: [],
			deliveryInstructionDetailId : '',
			sortByDeliveryInstructionDetail: '',
			sortDescDeliveryInstructionDetail: '',
			hasFailedDataDeliveryInstructionDetail: false,
			totalFailedDeliveryInstructionDetail: 0,
			totalSucceedDeliveryInstructionDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('deliveryinstruction/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('deliveryinstruction/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDeliveryInstructionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDeliveryInstructionForUpload : async function() {
			let _this = this;
			this.$http.get('deliveryinstruction/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.deliveryInstructions = [];
_this.deliveryInstructionDetails = [];


					if (response != null) {
						let result = response.data;
						_this.deliveryInstructions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDeliveryInstruction = _this.deliveryInstructions.length;

						_this.deliveryInstructionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDeliveryInstruction = true;
						_this.totalFailedDeliveryInstruction = 0;
						if(_this.deliveryInstructionsFailed == undefined || _this.deliveryInstructionsFailed.length === 0) _this.hasFailedDataDeliveryInstruction = false;
						if(_this.hasFailedDataDeliveryInstruction) _this.totalFailedDeliveryInstruction = _this.deliveryInstructionsFailed.length;
						_this.deliveryInstructionDetails = [];
						_this.deliveryInstructionDetailsFailed = [];
						_this.hasFailedDataDeliveryInstructionDetail = true;
						_this.totalSucceedDeliveryInstructionDetail = 0;
						result.forEach(function(element) {
							_this.deliveryInstructionDetails.push(...element.deliveryInstructionDetails.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedDeliveryInstructionDetail = _this.deliveryInstructionDetails.length;

							_this.deliveryInstructionDetailsFailed.push(...element.deliveryInstructionDetails.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.deliveryInstructionDetailsFailed == undefined || _this.deliveryInstructionDetailsFailed.length === 0) _this.hasFailedDataDeliveryInstructionDetail = false;
							if(_this.hasFailedDataDeliveryInstructionDetail) _this.totalFailedDeliveryInstructionDetail = _this.deliveryInstructionDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'deliveryinstruction/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DeliveryInstruction.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDeliveryInstruction = new DeliveryInstructionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
